import { useEffect, useMemo, useState } from "react";
import type * as type from "@vTypes";
import { useRosterDisplayShiftColumns } from "@/hooks/shift/useRosterDisplayShiftColumns";
import { dedupeShiftsByColumnGroup } from "@/utils/shift-util";
import type { CopyNurses } from "@utils/rosterCreate-util";

type UseRosterCreateDisplayShiftsParams = {
  readonly copyNursesWithWanted: CopyNurses;
  readonly defaultShiftCode: type.availableShifts[];
  readonly isUseMid: boolean | undefined;
  readonly year: number | null | undefined;
  readonly month: number | null | undefined;
  readonly scheduleId: string | null | undefined;
};

export function useRosterCreateDisplayShifts({
  copyNursesWithWanted,
  defaultShiftCode,
  isUseMid,
  year,
  month,
  scheduleId,
}: UseRosterCreateDisplayShiftsParams) {
  const [showPerShiftStats, setShowPerShiftStats] = useState(false);

  useEffect(() => {
    setShowPerShiftStats(false);
  }, [year, month, scheduleId]);

  const statsShiftCode = useMemo(
    () =>
      dedupeShiftsByColumnGroup(defaultShiftCode, {
        includeMid: isUseMid !== false,
      }),
    [defaultShiftCode, isUseMid]
  );

  const { displayShifts: rosterCreateShiftLegend } =
    useRosterDisplayShiftColumns(
      copyNursesWithWanted as {
        schedule?: (string | null)[] | null;
        schedule_ids?: (number | null)[] | null;
      }[],
      statsShiftCode,
      isUseMid,
      { includeBaselineMainTemplateColumns: true }
    );

  return {
    showPerShiftStats,
    setShowPerShiftStats,
    statsShiftCode,
    rosterCreateShiftLegend,
  };
}
